import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InstantQuotationVessel } from "../types/InstantQuotationVessel";

export const vesselTemplate = (
    vessel: InstantQuotationVessel,
    handleSelectVessel: any,
    t: any
) => {
    return (
        <div className="col-12">
            <div className="flex align-items-center justify-content-between">
                {vesselInfoCard(vessel)}
                <div>
                    <Button
                        label={t("instantQuotation.select")}
                        className="add-vessel-button"
                        onClick={() => handleSelectVessel(vessel)}
                    />
                </div>
            </div>
        </div>
    );
};

export const vesselInfoCard = (vessel: InstantQuotationVessel) => {
    const flagAspectRatio = 1.5;
    const flagHeight = 30;
    const flagWidth = flagHeight * flagAspectRatio;

    const flagSrc = vessel.FlagCode
        ? shipFlagUrl(vessel.FlagCode)
        : shipFlagUrl("unk");

    const defaultImage = (error: any) => {
        error.target.src = shipFlagUrl("unk");
        error.target.onerror = null;
    };

    return (
        <div className="flex align-items-center">
            <div>
                <img
                    style={{
                        height: `${flagHeight}px`,
                        width: `${flagWidth}px`
                    }}
                    src={flagSrc}
                    onError={(e) => defaultImage(e)}
                />
            </div>
            <div className="ml-3">
                <div className="ship-name">{vessel.ShipName}</div>
                <div className="ship-details">
                    {vessel.LRIMOShipNo} •{" "}
                    {vessel.FlagName + " (" + vessel.FlagCode + ")"} •{" "}
                    {vessel.ShipTypeName}
                </div>
            </div>
        </div>
    );
};

export const finderHeader = (
    handleVesselSearchChange: any,
    previousSearch: string,
    t: any
) => {
    return (
        <div>
            <div className="col-12 mb-2">
                <span>{t("instantQuotation.dialogTitle")}</span>
            </div>
            <div>
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-search"></i>
                    <InputText
                        autoFocus
                        placeholder={t("instantQuotation.searchPlaceholder")}
                        className="w-full"
                        defaultValue={previousSearch}
                        onChange={handleVesselSearchChange}
                    />
                </span>
            </div>
        </div>
    );
};

const shipFlagUrl = (flagCode: string) => {
    return `https://quotation.idwalmarine.com/images/flags/${flagCode.toLowerCase()}.svg`;
};
